export const GET_TOKEN_REQUEST = "GET_TOKEN_REQUEST";
export const GET_TOKEN_SUCCESS = "GET_TOKEN_SUCCESS";
export const GET_TOKEN_FAILURE = "GET_TOKEN_FAILURE";
export const VALIDATE_STUDENT_REQUEST = "VALIDATE_STUDENT_REQUEST";
export const VALIDATE_STUDENT_SUCCESS = "VALIDATE_STUDENT_SUCCESS";
export const VALIDATE_STUDENT_FAILURE = "VALIDATE_STUDENT_FAILURE";
export const CREATE_STUDENT_REQUEST = "CREATE_STUDENT_REQUEST";
export const CREATE_STUDENT_SUCCESS = "VALIDATE_STUDENT_SUCCESS";
export const CREATE_STUDENT_FAILURE = "CREATE_STUDENT_FAILURE";
export const VALIDATE_INTEREST_INVENTORY_REQUEST = "VALIDATE_INTEREST_INVENTORY_REQUEST";
export const VALIDATE_INTEREST_INVENTORY_SUCCESS = "VALIDATE_INTEREST_INVENTORY_SUCCESS";
export const VALIDATE_INTEREST_INVENTORY_FAILURE = "VALIDATE_INTEREST_INVENTORY_FAILURE";
export const SAVE_INTEREST_INVENTORY_CODE_REQUEST = "SAVE_INTEREST_INVENTORY_CODE_REQUEST";
export const SAVE_INTEREST_INVENTORY_CODE_SUCCESS = "SAVE_INTEREST_INVENTORY_CODE_SUCCESS";
export const SAVE_INTEREST_INVENTORY_CODE_FAILURE = "SAVE_INTEREST_INVENTORY_CODE_FAILURE";
export const RESET_STATE_REQUEST = "RESET_STATE_REQUEST";
export const GET_DISTRICT_REQUEST = "GET_DISTRICT_REQUEST";
export const GET_DISTRICT_SUCCESS = "GET_DISTRICT_SUCCESS";
export const GET_DISTRICT_FAILURE = "GET_DISTRICT_FAILURE";
export const SAVE_INTEREST_INVENTORY_DOC_REQUEST = "SAVE_INTEREST_INVENTORY_DOC_REQUEST";
export const SAVE_INTEREST_INVENTORY_DOC_SUCCESS = "SAVE_INTEREST_INVENTORY_DOC_SUCCESS";
export const SAVE_INTEREST_INVENTORY_DOC_FAILURE = "SAVE_INTEREST_INVENTORY_DOC_FAILURE";
export const FIND_COURSES_BY_HOLLANDCODE_REQUEST = "FIND_COURSES_BY_HOLLANDCODE_REQUEST";
export const FIND_COURSES_BY_HOLLANDCODE_SUCCESS = "FIND_COURSES_BY_HOLLANDCODE_SUCCESS";
export const FIND_COURSES_BY_HOLLANDCODE_FAILURE = "FIND_COURSES_BY_HOLLANDCODE_FAILURE";
export const DOWNLOAD_DOC_REQUEST = "DOWNLOAD_DOC_REQUEST";
export const DOWNLOAD_DOC_SUCCESS = "DOWNLOAD_DOC_SUCCESS";
export const DOWNLOAD_DOC_FAILURE = "DOWNLOAD_DOC_FAILURE";
export const DELETE_DOC_REQUEST = "DELETE_DOC_REQUEST";
export const DELETE_DOC_SUCCESS = "DELETE_DOC_SUCCESS";
export const DELETE_DOC_FAILURE = "DELETE_DOC_FAILURE";
export const SHOW_CONFIRM = 'SHOW_CONFIRM';
export const HIDE_CONFIRM = 'HIDE_CONFIRM';
export const SHOW_COURSES = 'SHOW_COURSES';
export const SHOW_RESULT = 'SHOW_RESULT';
export const SHOW_CHATBOT = 'SHOW_CHATBOT';
export const HIDE_CHATBOT = 'HIDE_CHATBOT';
export const ENABLE_REPLAY = 'ENABLE_REPLAY';
export const SHOW_COURSES_FOR_ALERTPAGE = 'SHOW_COURSES_FOR_ALERTPAGE';
export const SAVE_CONNECT_COUNSELLOR_REQUEST = 'SAVE_CONNECT_COUNSELLOR_REQUEST';
export const SAVE_CONNECT_COUNSELLOR_SUCCESS = 'SAVE_CONNECT_COUNSELLOR_SUCCESS';
export const SAVE_CONNECT_COUNSELLOR_FAILURE = 'SAVE_CONNECT_COUNSELLOR_FAILURE';
export const VALIDATE_INVENTORY_FOR_CHATSCORE_REQUEST = "VALIDATE_INVENTORY_FOR_CHATSCORE_REQUEST";
export const VALIDATE_INVENTORY_FOR_CHATSCORE_SUCCESS = "VALIDATE_INVENTORY_FOR_CHATSCORE_SUCCESS";
export const VALIDATE_INVENTORY_FOR_CHATSCORE_FAILURE = "VALIDATE_INVENTORY_FOR_CHATSCORE_FAILURE";
export const FIND_DOCUMENT_BY_ENGAGEMENT_REQUEST = "FIND_DOCUMENT_BY_ENGAGEMENT_REQUEST";
export const FIND_DOCUMENT_BY_ENGAGEMENT_SUCCESS = "FIND_DOCUMENT_BY_ENGAGEMENT_SUCCESS";
export const FIND_DOCUMENT_BY_ENGAGEMENT_FAILURE = "FIND_DOCUMENT_BY_ENGAGEMENT_FAILURE";
export const UPDATE_INTEREST_INVENTORY_CODE_REQUEST = "UPDATE_INTEREST_INVENTORY_CODE_REQUEST";
export const UPDATE_INTEREST_INVENTORY_CODE_SUCCESS = "UPDATE_INTEREST_INVENTORY_CODE_SUCCESS";
export const UPDATE_INTEREST_INVENTORY_CODE_FAILURE = "UPDATE_INTEREST_INVENTORY_CODE_FAILURE";
export const SAVE_FEEDBACK_REQUEST = "SAVE_FEEDBACK_REQUEST";
export const SAVE_FEEDBACK_SUCCESS = "SAVE_FEEDBACK_SUCCESS";
export const SAVE_FEEDBACK_FAILURE = "SAVE_FEEDBACK_FAILURE";
export const FETCH_NEAREST_CENTER_REQUEST = 'FETCH_NEAREST_CENTER_REQUEST'
export const FETCH_NEAREST_CENTER_SUCCESS = 'FETCH_NEAREST_CENTER_SUCCESS'
export const FETCH_NEAREST_CENTER_FAILURE = 'FETCH_NEAREST_CENTER_FAILURE'
export const FETCH_COURSE_NAME_REQUEST = 'FETCH_COURSE_NAME_REQUEST'
export const FETCH_COURSE_NAME_SUCCESS = 'FETCH_COURSE_NAME_SUCCESS'
export const FETCH_COURSE_NAME_FAILURE = 'FETCH_COURSE_NAME_FAILURE'